import { Column } from 'exceljs';
import { useState, useEffect } from 'react';
import { getLearningGamePlayerLeaderboard } from '../../../common/api/apicall';
import { months } from '../../../common/constants';
import Leaderboard from '../../../common/leaderboard';

import { IDatableColumn } from '../../../common/leaderboard/column.interface';
import { ILearningGamePlayerRank } from '../../../interface/learning-game-player-rank.interface';

const divisionId = '69425e929983245dbb15e314';
function HomeFirstHealthSafety() {
  const [data, setData] = useState<ILearningGamePlayerRank[]>([]);
  const columns: IDatableColumn[] = [
    {
      name: 'Employee Code',
      key: 'employeeId',
    },
    {
      name: 'Name',
      key: 'name',
    },
    {
      name: 'Highest Score',
      key: 'highestScore',
      type: 'number',
    },
    {
      name: 'Email ID',
      key: 'email',
      type: 'string',
    },
    {
      name: 'Date of Completion',
      key: 'completedAt',
      type: 'string',
      formatter: '',
    },
  ];

  const worksheetColumns = [
    { header: 'Employee Code', key: 'employeeId', width: 50 } as Column,
    { header: 'Name', key: 'name', width: 50 } as Column,
    {
      header: 'Highest Score',
      key: 'highestScore',
      width: 15,
      alignment: { horizontal: 'center' },
    } as Column,
    { header: 'Email ID', key: 'email', width: 15 } as Column,
    { header: 'Date of Completion', key: 'completedAt', width: 15 } as Column,
  ];

  useEffect(() => {
    getLearningGamePlayerLeaderboard(divisionId, {
      includeNonPostive: true,
      scorePosition: 'last',
      gameOver: true,
    })
      .then((res: any[]) => {
        const filteredPlayers: any[] = [];
        res.forEach((player) => {
          player['name'] =
            (player['firstName'] || '') +
            ' ' +
            (player['lastName'] || '') +
            (player['lastname'] || '');

          player['highestScore'] =
            player['highestScoreHistory'] || player['highestScore'];

          player.email = player.email;
          if (player.extraDetail) {
            player['employeeId'] =
              player.extraDetail['employeeid'] ||
              player.extraDetail['employeeId'];
          }

          if (player['completedAt']) {
            const date = new Date(player['completedAt']);
            player['completedAt'] = `${date.getDate()} ${
              months[date.getMonth()]
            }, ${date.getFullYear()}`;
          }
          if (player.extraDetail) {
            filteredPlayers.push(player);
          }
        });
        setData(filteredPlayers);
      })
      .catch((error) => console.log('error: ', error));
  }, []);

  return (
    <Leaderboard
      // data={data.sort(
      //   (a, b) =>
      //     new Date(b.completedAt).getTime() - new Date(a.completedAt).getTime(),
      // )}
      data={
        data
        .filter(item => {
          const date = new Date(item.completedAt);
          return date >= new Date("2025-03-31");
        })
  .sort((a, b) => new Date(b.completedAt).getTime() - new Date(a.completedAt).getTime())
      }
      columns={columns}
      type="new"
      total={  data
        .filter(item => {
          const date = new Date(item.completedAt);
          return date >= new Date("2025-03-31");
        }).length}
      name="KYC and AML"
      showIndex
      downloadable={true}
      worksheetColumns={worksheetColumns}
    />
  );
}

export default HomeFirstHealthSafety;
